export default __webpack_public_path__ + "static/media/graph-type-2.ed03dbdd.png";